export const version = '2.65.0';
//# sourceMappingURL=version.js.map